class Carousel extends HTMLElement {
  constructor() {
    super();
    this.carouselCalc = this.carouselCalc.bind(this);
  }

  connectedCallback() {
    this.carouselCalc();
  }

  carouselCalc() {
    const carousel = this.querySelector('.carousel');
    const carouselBtns = Array.from(this.querySelectorAll('.sliderbtn'));
    const card = this.querySelector('.carousel-card');

    if (!carousel || !card) return;

    const cardWidth = card.offsetWidth;
    const carouselChildrens = Array.from(carousel.children);
    const childPerView = Math.round(carousel.offsetWidth / cardWidth);

    // Clone last n elements to the start
    carouselChildrens
      .slice(-childPerView)
      .reverse()
      .forEach((child) => {
        carousel.insertAdjacentHTML('afterbegin', child.outerHTML);
      });

    // Clone first n elements to the end
    carouselChildrens
      .slice(0, childPerView)
      .forEach((child) => {
        carousel.insertAdjacentHTML('beforeend', child.outerHTML);
      });

    // Button event handlers
    carouselBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.getAttribute('data-direction') === 'right') {
          carousel.scrollLeft += cardWidth;
        } else if (btn.getAttribute('data-direction') === 'left') {
          carousel.scrollLeft -= cardWidth;
        }
      });
    });

    // Loop scroll
    carousel.addEventListener('scroll', () => {
      if (carousel.scrollLeft === 0) {
        carousel.classList.remove('tw-scroll-smooth');
        carousel.scrollLeft = carousel.scrollWidth - 2 * carousel.offsetWidth;
        carousel.classList.add('tw-scroll-smooth');
      } else if (
        Math.ceil(carousel.scrollLeft) ===
        carousel.scrollWidth - carousel.offsetWidth
      ) {
        carousel.classList.remove('tw-scroll-smooth');
        carousel.scrollLeft = carousel.offsetWidth;
        carousel.classList.add('tw-scroll-smooth');
      }
    });
  }
}

// Register the custom element
customElements.define('infinite-carousel', Carousel);

       


var modaleBtns = document.querySelectorAll(".modaleBtns");
          var closeBtns = document.querySelectorAll(".closeBtns");

          // Open the modal
          for ( var modaleBtn in modaleBtns ) {
            modaleBtns[modaleBtn].onclick = function() {
              let parent = this.closest('.carousel-card')
              let modal = parent.querySelector('.my_modal')
              modal.showModal();
            }
          }

          // Close the modal
          for ( var closeBtn in closeBtns ) {
            closeBtns[closeBtn].onclick = function() {
              let parent = this.closest('.carousel-card')
              let modal = parent.querySelector('.my_modal')
              modal.close();
            }
          }
          
          // Close the modal by clicking Escape
          document.addEventListener("keydown", function (event) {
            if (event.key === "Escape") {
              closeModal();
            }
          });
        